import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Marquee } from "@/components/site/Marquee";
import { Categories } from "@/components/site/Categories";
import { WhyChooseUs, Process } from "@/components/site/WhyProcess";
import { Founders, MissionVision } from "@/components/site/Founders";
import { Contact } from "@/components/site/Contact";

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-navy text-white" data-testid="app-root">
      <Toaster position="top-center" richColors theme="dark" />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Marquee />
        <Categories />
        <WhyChooseUs />
        <Process />
        <MissionVision />
        <Founders />
        <Contact />
      </main>
    </div>
  );
}

export default App;
